import Cookies from 'js-cookie'
import authStore from 'modules/reports/stores/auth'
import {setLocalStorageItems} from './localStorage'
const jwt = require('jsonwebtoken')

const jwtCookie = Cookies.get('pwa_jwt')

export default function jwtDecodeAndStore(callback) {
  try {
    const decryptedJwt = jwt.verify(jwtCookie, process.env.REACT_APP_JWT_PUBLIC_KEY)
    const {
      access_token,
      account_id,
      user_id,
      email,
      exp,
      session_expire,
      temp_password,
    } = decryptedJwt

    const storageItems = {
      jwt: JSON.stringify(decryptedJwt),
      token: JSON.stringify(access_token),
      user_email: email,
      account_id: JSON.stringify(account_id),
      user_id: JSON.stringify(user_id),
      exp: JSON.stringify(exp),
      session_expire: JSON.stringify(session_expire),
      temp_password: JSON.stringify(temp_password),
    }

    setLocalStorageItems(storageItems)
    callback()

    authStore.setUserData({id: user_id, email, account_id})
  } catch (error) {
    console.warn(`${error.message} and should redirect to ${process.env.REACT_APP_REDIRECT_URL}`)
    if (window !== window.parent) {
      //window.top.location.href = process.env.REACT_APP_REDIRECT_URL
    } else {
      // window.location.href = process.env.REACT_APP_REDIRECT_URL
    }
    return
  }
}
